const Footer = () => (
  <footer className="py-6 px-4 bg-blue-100 text-[#173861] text-center text-sm font-medium">
    <span className="block mb-1">&copy; 2026 Infinity Energy Solar | All Rights Reserved</span>
    <span className="text-xs text-gray-400">Created by Petar Adamov</span>
  </footer>
);
export default Footer;
